


export const CardHorizontal = ({img, title, description, author, optional}) => {


        
    return (
        <div>
            <div className="card mb-3">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={img} className="img-fluid rounded-start" alt={title}/>
                    </div>
                    <div className="col-md-8">
                        <div className="card-body">
                            <h5 className="card-title"> {title} </h5>
                            <p className="card-text"> {description} </p>
                            <p className="card-text"><small className="text-muted"> {author} </small></p>
                            <div>
                                {optional}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
